namespace GeniuzPOS.Purchase {
    export namespace PoPurInvoiceService {
        export const baseUrl = 'Purchase/PoPurInvoice';

        export declare function Create(request: Serenity.SaveRequest<PoPurInvoiceRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoPurInvoiceRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoPurInvoiceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoPurInvoiceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UpdateCancelAndIrUseFg(request: UpdateCancelAndIrUseFgRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoPurInvoice/Create",
            Update = "Purchase/PoPurInvoice/Update",
            Delete = "Purchase/PoPurInvoice/Delete",
            Retrieve = "Purchase/PoPurInvoice/Retrieve",
            GetNextNumber = "Purchase/PoPurInvoice/GetNextNumber",
            List = "Purchase/PoPurInvoice/List",
            UpdateCancelAndIrUseFg = "Purchase/PoPurInvoice/UpdateCancelAndIrUseFg"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'GetNextNumber', 
            'List', 
            'UpdateCancelAndIrUseFg'
        ].forEach(x => {
            (<any>PoPurInvoiceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
